export default __webpack_public_path__ + "static/media/study_selected.0709bc58.svg";